import {
  Box,
  Button,
  Group,
  JsonInput,
  LoadingOverlay,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck } from "@tabler/icons-react";
import { createMenuContent } from "../../api/ApiMenuContent";
import ButtonClose from "../../common/ButtonClose/ButtonClose";
import { MenuContentModel } from "../../model/MenuContentModel";

const CreateViewMenu = () => {
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm<MenuContentModel>({
    validateInputOnChange: true,
    initialValues: {
      //   id: "0",
      html: "",
      idMenu: "",
    },
    validate: {
      html: (value) => (value ? null : "Nội dung không được để trống"),
      idMenu: (value) => (value ? null : "ID menu không được để trống"),
    },
  });
  const handleSubmit = async (values: MenuContentModel) => {
    console.log("Submitted values:", values);
    try {
      open();
      await createMenuContent({
        ...values,
        idMenu: Number(values.idMenu),
      });
      close();
      modals.closeAll();
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={950}
        maw={950}
        mx="auto"
        onSubmit={form.onSubmit((e: any) => {
          handleSubmit(e);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Group grow wrap="nowrap" mt="lg" gap={"lg"} mb={"md"}>
          <TextInput
            label={"ID menu"}
            placeholder={"Nhập ID menu"}
            withAsterisk
            mt="md"
            type="number"
            {...form.getInputProps("idMenu")}
          />
        </Group>
        <JsonInput
          placeholder="Nhập nội dung..."
          formatOnBlur
          autosize
          // validationError="Invalid JSON"
          minRows={9}
          {...form.getInputProps("html")}
        />

        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <ButtonClose />
        </Group>
      </Box>
    </>
  );
};

export default CreateViewMenu;
